import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Row, Col, Icon, Form } from 'antd';
import VideoDropzone from '../../../../VideoDropzone';

const PRIMARY_LANGUAGE = 'de';

class Video extends Component {
  constructor(props) {
    super(props);

    let { video = null } = props.data || {};
    if (props.data?.translations?.video) video = props.data?.translations?.video?.[props.language] || null;

    this.state = {
      video,
      rejection: null,
    };
  }

  // The backend copies an uploaded video to every language without an own file,
  // so a single language with a video is enough for the whole post.
  hasAnyVideo = () => {
    const { getFieldValue } = this.props.form;
    const videos = getFieldValue('attachment.translations.video') || {};

    return Object.values(videos).some((el) => !!el);
  };

  validateVideo = (rule, value, callback) => {
    if (this.props.language !== PRIMARY_LANGUAGE || this.hasAnyVideo()) {
      callback();
      return;
    }

    callback('Bitte wähle ein Video aus, bevor du den Post veröffentlichst.');
  };

  onVideoFileSelected = async (files) => {
    const { setFieldsValue } = this.props.form;

    setFieldsValue({
      [`attachment.translations.video.${this.props.language}`]: files[0],
    });

    this.setState({
      video: files[0],
      rejection: null,
    });
  };

  onVideoFileRejected = (rejection) => {
    this.setState({ rejection });
  };

  removeVideo = () => {
    const { setFieldsValue } = this.props.form;

    setFieldsValue({
      [`attachment.translations.video.${this.props.language}`]: null,
    });

    this.setState({
      video: null,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { video, rejection } = this.state;

    const decorate = getFieldDecorator(`attachment.translations.video.${this.props.language}`, {
      initialValue: video,
      rules: [{ validator: this.validateVideo }],
    });

    // The dropzone itself has to be the decorated element: rc-form injects an onChange into it, and
    // on a plain DOM wrapper that handler would receive the bubbling change event of the hidden file
    // input and store its "C:\fakepath\..." string instead of the selected file.
    return (
      <Row type="flex" align="middle">
        <Col span={24}>
          <Form.Item style={{ marginBottom: 0 }}>
            {video ? (
              decorate(
                <div style={{ position: 'relative', height: 250, textAlign: 'center' }}>
                  <video
                    preload="metadata"
                    src={video.preview || video.raw}
                    autoPlay={false}
                    muted={true}
                    controls={false}
                    style={{
                      height: 250,
                    }}
                  />
                  <div className="video-overlay">
                    <div className="inner-overlay-two">
                      <div className="inner-overlay-three" onClick={this.removeVideo}>
                        <Icon type="close" />
                      </div>
                    </div>
                  </div>
                </div>
              )
            ) : (
              <div style={{ position: 'relative', height: 100 }}>
                {decorate(
                  <VideoDropzone
                    icon="plus"
                    multiple={false}
                    onFileSelected={this.onVideoFileSelected}
                    onFileRejected={this.onVideoFileRejected}
                  />
                )}
              </div>
            )}
          </Form.Item>
          {!video && rejection && <div style={{ color: '#f5222d', padding: '5px 0' }}>{rejection}</div>}
        </Col>
      </Row>
    );
  }
}

Video.propTypes = {
  form: PropTypes.object.isRequired,
  language: PropTypes.string,
};

export default Video;
